<template>
    <!-- 课票订单详情-票券订单列表  用户票券管理 -->
    <div>
        <content-view>
            <div class="wrap-container-in mt16">
                <div>【用户票券号：{{userTicketId}} 】的赠送详情</div>
                <div class="mb8 mt8">
                    <span class="mr32">活动赠送：{{giveData.newTicketDetails || '--'}}</span>
                </div>
                <div class="mb8 mt8">
                    <span class="mr32">购买时是否加赠：{{giveData.extra ? '是' : '否'}}</span>
                    <span class="mr32">加赠详情：{{giveData.extraTicketDetails || '--'}}</span>
                    <span class="mr32">加赠理由：{{giveData.reason || '--'}}</span>
                    <span>加赠操作人：{{giveData.operator || '--'}}</span>
                </div>
                <a-table :pagination="false" bordered :dataSource="dataSourceGive" :columns="columnsGive" :rowKey="(record, index) => index">
                    <span slot="utid" slot-scope="utid">{{Boolean(utid) ? utid : "-"}}</span>
                    <span slot="type" slot-scope="type">{{Boolean(type) ? ['','期限卡','次卡','套餐票'][type] : "-"}}</span>
                    <span slot="state" slot-scope="state">{{["-",'待支付','支付失败','已支付','已过期','已失效','退款中','已退款','退款失败','已禁用', '已冻结'][state ? state : 0]}}</span>
                    <span slot="expirationDate" slot-scope="a, row">
                        剩余使用次数:{{row.total !== null ? `${row.total === -1 ? '不限次' : row.total - row.used}；` : "-"}}
                        有效期:{{ row.expirationDate ? `:${row.expirationDate.substr(0,10)}` : "-"}}
                    </span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('usingDetailUser')">
                            <span v-if="!Boolean(row.userTicketId) || row.state == 1 || row.state == 2" class="text-disabled">使用详情</span>
                            <router-link v-else class="text-primary" :to="{name:'usingDetail', query: {userTicketId: row.userTicketId}}">使用详情</router-link>
                            <a-divider type="vertical"/>
                        </span>

                        <span v-if="getBtnByAuth('ticketCourseState')">
                            <a-popconfirm
                            v-if="Boolean(row.userTicketId) && row.state == 9"
                            title="确定将该票券订单取消禁用吗?"
                            @confirm="orderState(row.userTicketId, false, true)"
                            >
                                <a class="text-primary">取消禁用</a>
                            </a-popconfirm>
                            <a-popconfirm
                            v-else-if="Boolean(row.userTicketId) && row.state == 3 || row.state == 8"
                            title="确定将该票券订单禁用吗?"
                            @confirm="orderState(row.userTicketId, true, true)"
                            >
                                <a class="text-primary">禁用</a>
                            </a-popconfirm>
                            <span v-else class="text-disabled">禁用</span>
                        </span>
                    </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    const columnsGive = [
    {
        title: "用户票券号",
        dataIndex: "userTicketId",
        scopedSlots: { customRender: "utid" }
    },
    {
        title: "会员手机号",
        dataIndex: "account"
    },
    {
        title: "票券名称",
        dataIndex: "name"
    },
    {
        title: "票券类型",
        dataIndex: "type",
        scopedSlots: { customRender: "type" }
    },
    {
        title: "票券状态",
        dataIndex: "state",
        scopedSlots: { customRender: "state" }
    },
    {
        title: "票券信息",
        dataIndex: "expirationDate",
        scopedSlots: { customRender: "expirationDate" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "give-ticket",
        components: {},
        props: {},
        data() {
            return {
                giveData: {},
                dataSourceGive: [],
                columnsGive,
                userTicketId: ''
            };
        },
        methods: {
            // 获取购票订单列表
            userTicketGiveDetails() {
                this.$api.order
                .userTicketGiveDetails({
                    params: 
                    {   
                        userTicketId: this.userTicketId,
                    }
                })
                .then(res => {
                    this.dataSourceGive = res.userTicketList;
                    this.giveData = res
                });
            },
            // 更改禁用解禁状态
            orderState(id, flag) {
                this.$api.order.forbidden({
                    params: {id: id, flag: flag}
                })
                .then(res => {
                    this.$message.success('操作成功',2);
                    this.userTicketGiveDetails()
                })
            },

        },
        created() {},
        mounted() {
            this.userTicketId = this.$route.query.userTicketId;
            this.userTicketGiveDetails();
        },
        watch: {
        }
    };
</script>
<style lang="scss">
.title-ticket {
    margin-bottom: 8px;
    font-size: 16px;
    color: #000;
    font-weight: 700;
}
.tr-active {
    background-color: #fff6ee;
}
</style>